module.exports = __webpack_public_path__ + "static/media/no-records.b5ad74bb.svg";